import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AccountDataSource } from 'app/core/models/account';

export const accountSetupGuard: CanActivateFn = (_, state) => {
    const accountDataSource = inject(AccountDataSource);
    const router = inject(Router);

    return accountDataSource.getAccountIfExists().pipe(
        map((account) => {
            if (account) {
                return true;
            }

            return router.createUrlTree(['/complete-signup'], {
                queryParams: {
                    returnUrl: state.url || '/'
                }
            });
        })
    );
};

export const signupCompletionGuard: CanActivateFn = (route) => {
    const accountDataSource = inject(AccountDataSource);
    const router = inject(Router);
    const returnUrl = getSafeReturnUrl(route.queryParamMap.get('returnUrl'));

    return accountDataSource.getAccountIfExists().pipe(
        map((account) => {
            if (account) {
                return router.parseUrl(returnUrl);
            }

            return true;
        })
    );
};

function getSafeReturnUrl(returnUrl: string | null): string {
    if (!returnUrl || !returnUrl.startsWith('/')) {
        return '/';
    }

    if (returnUrl.startsWith('/complete-signup')) {
        return '/';
    }

    return returnUrl;
}
